<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page row-start">
        <div class="form-item-char30">
            <label class="label-caption">Opção de Relatório</label>
            <select v-model="opcaoSelecionada">
                <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
            </select>
        </div>

        <div class="form-item-data">
            <label class="label-caption" >Data Coleta</label>
            <input type="date" v-model="edData" />
        </div>

        <div class="form-item">
            <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="idEstabelecimento" />
        </div>

        <button type="button" class="buttom-icon--printer" @click="openReport" />
        <button type="button" class="buttom-icon--close" @click="closePage" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';

const emit = defineEmits(['close']);

const edData = ref(null);
const msgAlerta = ref(null);
const idEstabelecimento = ref(0);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'coletaCinta1', descricao: 'Opção I'},
    {id: 'coletaCinta2', descricao: 'Opção II'},
]);
const opcaoSelecionada = ref('coletaCinta1');


function closePage() {emit('close');}

async function openReport() {
    const qrCode = crypto.randomUUID();
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: idEstabelecimento.value,
            datap1: edData.value,
            strp1: qrCode,
            idusuario: globalStore.idusuario
        };
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>